/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The PieChartItem model module.
* @module model/PieChartItem
* @version 1.0.0
*/
export default class PieChartItem {
    /**
    * Constructs a new <code>PieChartItem</code>.
    * Значение кругового графика
    * @alias module:model/PieChartItem
    * @class
    * @param name {String} 
    * @param value {Number} 
    */

    constructor(name, value) {
        

        
        

        this['name'] = name;this['value'] = value;

        
    }

    /**
    * Constructs a <code>PieChartItem</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/PieChartItem} obj Optional instance to populate.
    * @return {module:model/PieChartItem} The populated <code>PieChartItem</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PieChartItem();

            
            
            

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {String} name
    */
    name = undefined;
    /**
    * @member {Number} value
    */
    value = undefined;








}


